<template>
  <div>
    <div class="box1">
      <div class="fvlr count">
        <div class="fhlc moneyBox">
          <span class="money">￥{{ insurance.claim_amount.toFixed(2) }}</span
          ><span>补偿金额累计</span>
        </div>
        <div class="time fvl"><van-icon name="clock-o" class="clock-o" />{{ insurance.left_days }}</div>
      </div>

      <div class="fvlr top">
        <div v-for="(item, index) in times" :key="index">{{ item }}</div>
      </div>
      <div class="fvlr bottom">
        <div>左前轮（次）</div>
        <div>右前轮（次）</div>
        <div>左后轮（次）</div>
        <div>右后轮（次）</div>
      </div>
    </div>
    <div class="box1" v-for="(item, index) in insurance.claims" :key="index">
      <div class="fvlr count">
        <div class="fhlc moneyBox">
          <span class="money fvl">
            ￥{{ item.claim_amount.toFixed(2) }}
            <div class="tyrelabel">{{ item.tyre_group_label }}</div>
          </span>
          <span>补偿金额（70%零售价）</span>
        </div>
        <van-icon size="22" name="todo-list" @click="toTyreExclusiveOrder" />
      </div>
      <div class="tyre-desc fvl">
        <div class="item">
          <div class="title">{{ item.brand_cn }}</div>
          <div class="sub-title">{{ item.spec }}</div>
        </div>
        <div class="item">
          <div class="title">{{ addEightHour(item.created_at, 'day') }}</div>
          <div class="sub-title">补偿时间</div>
        </div>
      </div>
      <div class="fvlrw">
        <img class="showImg" v-for="(imgObj, i) in item.images" @click="showImg(item.images, i)" :key="imgObj.id" :src="imgObj.url" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { myInsurance } from '@/assets/js/insurance.js'
import { ImagePreview } from 'vant'
import { addEightHour } from '@/util/index'
import { getMyInsurance } from '@/api/tyre'
import { useRouter } from 'vue-router'
export default {
  setup() {
    let { insurance, vehicle } = myInsurance
    const router = useRouter()
    const state = reactive({
      insurance,
      vehicle,
      times: []
    })
    const toTyreExclusiveOrder = () => {
      router.push('/tyreExclusiveOrder')
    }
    onMounted(async () => {
      let times = [0, 0, 0, 0]
      let { insurance, vehicle } = await getMyInsurance()
      let claims = insurance.claims
      state.insurance = insurance
      state.vehicle = vehicle
      for (const item of claims) {
        times[item.tyre_group - 1] = item.quantity
      }
      state.times = times
    })
    const showImg = (images, i) => {
      console.log(images)
      let imgArr = []
      for (const item of images) {
        imgArr.push(item.url)
      }
      console.log(imgArr)
      ImagePreview({
        images: imgArr,
        startPosition: i
      })
    }
    return {
      ...toRefs(state),
      showImg,
      addEightHour,
      toTyreExclusiveOrder
    }
  }
}
</script>

<style lang="scss" scoped>
.box1 {
  box-sizing: border-box;
  padding: 16px 20px;
  position: relative;
  background: rgba(255, 255, 255, 0.6);
  margin-bottom: 8px;
}
.box2 {
  margin-top: 8px;
}
.time {
  font-size: 12px;
  color: #fff;
  width: 94px;
  margin-right: -20px;
  border-radius: 20px 0 0 20px;
  padding: 3px 0 3px 5px;
  box-sizing: border-box;
  background-image: linear-gradient(#5ebde4, #3088c5);
  .clock-o {
    margin-right: 10px;
  }
}
.count {
  margin-bottom: 16px;
}
.fvlr {
  text-align: center;
}
.top {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
}
.bottom {
  font-size: 12px;
  color: #666666;
}
.top,
.bottom {
  div {
    width: 98px;
  }
}
.moneyBox {
  font-size: 12px;
  color: #666666;
}
.money {
  font-size: 16px;
  font-weight: 900;
  color: #000000;
  margin-bottom: 4px;
}
.tyrelabel {
  font-size: 12px;
  padding: 2px 3px;
  border-radius: 12px;
  background: #d1c9c9;
  width: 50px;
  margin-left: 8px;
  color: #fff;
  transform: scale(0.8);
}
.tyre-desc {
  .item {
    width: 100px;
    text-align: left;
    font-size: 14px;
  }
  .sub-title {
    font-size: 12px;
    color: #666666;
    margin-top: 8px;
  }
}
.showImg {
  width: 75px;
  height: 75px;
  margin-top: 10px;
  border-radius: 5px;
}
.fvlrw {
  margin-top: 10px;
}
</style>
